module.exports = __webpack_public_path__ + "static/GorditaMedium-483365f08c49ba78132189da498468d4.woff2";